import { useState } from "react";
import { useBiLogger } from "../../../bi/useBiLogger";
import { PAGE_AREA } from "../../../bi/constants";

interface UseRecreateModalProps {
  onGenerate: (url: string) => Promise<boolean>;
  onClose: () => void;
  validateUrl: (url: string) => boolean;
  regexValidationError: string;
  apiValidationError: string;
  pageArea: PAGE_AREA;
}

export const useRecreateModal = ({
  onGenerate,
  onClose,
  validateUrl,
  regexValidationError,
  apiValidationError,
  pageArea,
}: UseRecreateModalProps) => {
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [url, setUrl] = useState<string>("");
  const [urlError, setUrlError] = useState<string | undefined>(undefined);
  const biLogger = useBiLogger();

  const handleGenerateSite = async () => {
    if (isGenerating) return;

    if (!validateUrl(url)) {
      biLogger.handleError({
        additionalInfo: url,
        errorDesc: "Invalid URL",
        errorMessage: regexValidationError,
      });
      setUrlError(regexValidationError);
      return;
    }

    setUrlError(undefined);
    setIsGenerating(true);

    const success = await onGenerate(url);

    if (!success) {
      setUrlError(apiValidationError);
      setIsGenerating(false);
    }
  };

  const handleCancel = () => {
    if (isGenerating) return;

    setUrl("");
    setUrlError(undefined);
    setIsGenerating(false);
    onClose();
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (validateUrl(e.target.value)) {
      setUrlError(undefined);
    }
    setUrl(e.target.value);
  };

  return {
    isGenerating,
    url,
    urlError,
    handleGenerateSite,
    handleCancel,
    handleUrlChange,
  };
};
